import { render } from "./RatingExplanationComponent.vue?vue&type=template&id=0d85437f&scoped=true"
import script from "./RatingExplanationComponent.vue?vue&type=script&lang=js"
export * from "./RatingExplanationComponent.vue?vue&type=script&lang=js"

import "./RatingExplanationComponent.vue?vue&type=style&index=0&id=0d85437f&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d85437f"]])

export default __exports__